import { makeStyles } from "@material-ui/core/styles";
import { EFlagPriority, flagLevels } from "components/VetExamsTable/helper";

export default makeStyles(() => {
  const { none, lowest, medium, highest } = flagLevels;

  return {
    popoverContent: {
      border: "1px solid #232323",
      padding: "4px 8px",
      borderRadius: 3,
      "&:after": {
        content: "''",
        position: "absolute",
        display: "block",
        backgroundColor: "#fff",
        borderBottom: "1px solid #232323",
        borderRight: "1px solid #232323",
        transform: "rotateZ(45deg)",
        bottom: -4,
        left: "calc(50% - 4px)",
        width: 8,
        height: 8,
        zIndex: 1500,
        borderTopLeftRadius: 3
      }
    },
    paper: {
      overflow: "initial",
      boxShadow: "none"
    },
    icon: {
      width: 21,
      height: 21,
      marginLeft: 12,
      "&:first-child": {
        marginLeft: 0
      },
      "&.selected": {
        backgroundColor: "transparent"
      }
    },
    [EFlagPriority.NONE]: {
      color: none,
      transform: "rotateZ(90deg)",
      boxShadow: "0px 0px 5px 0px rgba(0, 0, 0, 0.15)"
    },
    [EFlagPriority.LOWEST]: {
      color: lowest,
      backgroundColor: lowest,
      "&:hover": {
        color: lowest,
        backgroundColor: lowest
      },
      "&.selected": {
        color: lowest
      }
    },
    [EFlagPriority.MEDIUM]: {
      color: medium,
      backgroundColor: medium,
      "&:hover": {
        color: medium,
        backgroundColor: medium
      },
      "&.selected": {
        color: medium
      }
    },
    [EFlagPriority.HIGHEST]: {
      color: highest,
      backgroundColor: highest,
      "&:hover": {
        color: highest,
        backgroundColor: highest
      },
      "&.selected": {
        color: highest
      }
    }
  };
});
